import axios from 'axios'
import store from '@/store'
// import * as http from '@/libs/http'
const apimock = () => import(/* webpackChunkName: "devtools" */ '@/api-mock')

// API のアクセスキー
const accessKey = 'access:key'

// VUE_APP_API_TYPE = mix のときに除外する URL
const excludesPaths = [
  '/org/.+/auth'
]

/**
 * API クライアントを作成するクラス
 */
class ApiClientCreator {
  /**
   * コンストラクタ
   */
  constructor () {
    this.useMock = !!process.env.VUE_APP_API_TYPE
    this.mixMode = (process.env.VUE_APP_API_TYPE === 'mix')
    this.useLog = !!process.env.VUE_APP_API_LOG

    if (this.mixMode) {
      this.paths = excludesPaths.map(pat => (new RegExp(`^${pat.replace('/', '\\/')}$`)))
    }
  }

  /**
   * API クライアントを作成する
   *
   * @returns API クライアントを返す
   */
  create () {
    // adapter を選定する
    const adapter = this.useMock ? this.mockAdapter : null

    // API クライアントを作成する
    const client = axios.create({
      baseURL: process.env.VUE_APP_API_BASEURL,
      headers: {
        common: {
          'X-BOOKIN-API-ACCESSKEY': accessKey
        },
        post: {
          'Content-Type': 'application/json'
        },
        put: {
          'Content-Type': 'application/json'
        }
      },
      adapter
    })

    // mix mode 用の interceptors を設定する
    if (this.mixMode) {
      this.interceptMixMode(client)
    }

    // api log 用の interceptors を設定する
    if (this.useLog) {
      this.interceptLog(client)
    }

    // API アクセストークン用の interceptors を設定する
    this.interceptAccessToken(client)

    return client
  }

  /**
   * api mock を機能させるアダプタ
   *
   * @param {Request} config 送信設定
   * @returns {Promise} mock の処理結果
   */
  async mockAdapter (config) {
    const module = await apimock()
    return module.default(config)
  }

  /**
   * API アクセストークン用の interceptors を設定する
   *
   * @param {Axios} client API クライアント
   */
  interceptAccessToken (client) {
    client.interceptors.request.use(config => {
      const token = store.getters['api/token']
      if (token) {
        config.headers.common['X-Token'] = token
      }

      return config
    })
  }

  /**
   * mix mode 用の interceptors を設定する
   *
   * @param {Axios} client API クライアント
   */
  interceptMixMode (client) {
    client.interceptors.request.use(config => {
      // excludesPaths にあるパスのリクエストは mock adapter を使用しない
      if (this.paths.some(re => re.test(config.url))) {
        config.adapter = null
      }

      return config
    })
  }

  /**
   * api log 用の interceptors を設定する
   *
   * @param {Axios} client API クライアント
   */
  interceptLog (client) {
    client.interceptors.request.use(config => {
      store.commit('apilog/request', config)
      return config
    })

    client.interceptors.response.use(response => {
      store.commit('apilog/response', response)
      return response
    }, err => {
      if (err.isAxiosError) {
        store.commit('apilog/response', err.response)
      }
      return Promise.reject(err)
    })
  }
}

export default (new ApiClientCreator()).create()
